import React, { useEffect, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const ResumePreview = ({ file }) => {
  const [pageWidth, setPageWidth] = useState(420);

  useEffect(() => {
    const updateWidth = () => {
      setPageWidth(Math.min(480, window.innerWidth - 64));
    };

    updateWidth();
    window.addEventListener('resize', updateWidth);
    return () => window.removeEventListener('resize', updateWidth);
  }, []);

  return (
    <div className="resume-preview">
      <a
        href={file}
        target="_blank"
        rel="noopener noreferrer"
        className="resume-preview-link"
        aria-label="Open resume in a new tab"
      >
        <Document
          file={file}
          loading={<div className="resume-preview-status">Loading resume preview...</div>}
          error={<div className="resume-preview-status resume-preview-error">Unable to load resume.</div>}
        >
          <div className="resume-preview-page">
            <Page
              pageNumber={1}
              width={pageWidth}
              renderTextLayer={false}
              renderAnnotationLayer={false}
            />
          </div>
        </Document>
      </a>

      <a href={file} target="_blank" rel="noopener noreferrer" className="btn btn-primary resume-view-btn">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="download-icon">
          <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <polyline points="15,3 21,3 21,9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <line x1="10" y1="14" x2="21" y2="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        View Resume
      </a>
    </div>
  );
};

export default ResumePreview;
